import script from "./currentAssetDerivatve.vue?vue&type=script&setup=true&lang=js"
export * from "./currentAssetDerivatve.vue?vue&type=script&setup=true&lang=js"

import "./currentAssetDerivatve.vue?vue&type=style&index=0&id=45344534&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45344534"]])

export default __exports__